import React from 'react';

/**
 * Reporting Currency field - pinned to USD.
 *
 * The lake is USD-only and NO FX conversion exists anywhere in the reports
 * engine, so the former multi-currency <select> only relabeled raw-USD numbers
 * with a foreign symbol (a $100 balance shown as "EUR100.00"). This renders a
 * disabled, read-only USD field so the UI cannot imply a conversion the backend
 * cannot perform. Popups keep their `currency` state at 'USD' and still send
 * currency: 'USD' through the params plumbing.
 */
const ReportingCurrencyField = ({ darkMode = false }) => (
  <div>
    <label className={`block text-sm font-medium mb-2 ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>
      Reporting Currency
    </label>
    <input
      type="text"
      value="USD - US Dollar"
      readOnly
      disabled
      className={`w-full px-3 py-2 border rounded-lg ${darkMode ? 'bg-[#1a1a1a] border-white/10 text-gray-400' : 'bg-gray-50 border-gray-300 text-gray-500'}`}
    />
  </div>
);

export default ReportingCurrencyField;
